export default {
  STATUT_EN_ATTENTE: 0,
  STATUT_EN_COURS: 1,
  STATUT_EN_PAUSE: 2,
  STATUT_TERMINEE: 3,
};
